import { actionTypes } from '@/types';

export default function loanerStart({ state, dispatch }) {
	dispatch(actionTypes.setExhibition, {
		exhibitionID: state.dataSourceCFG.landingExhibition.exhibitionID,
	});
}
